import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { ModalService } from '@features/modals/services/modal.service';

export interface CanLeaveAutobet {
  isAutoBetRunning(): boolean;
}

export const canDeactivateAutobet: CanDeactivateFn<CanLeaveAutobet> = (component) => {
  if (!component.isAutoBetRunning()) return true;

  const modalService = inject(ModalService);
  return modalService.openModal('AutoBetLeaveConfirm').pipe(
    map((result) => result === true),
    take(1)
  );
};
